const ENV = import.meta.env.VITE_APP_NODE_ENV;

const BANNER_CONFIG: Record<string, { label: string; color: string }> = {
  develop: { label: 'THIS IS DEV SITE', color: '#1677ff' },
  staging: { label: 'THIS IS STAGING SITE', color: '#faad14' },
};

const AppEnvBanner = () => {
  const config = BANNER_CONFIG[ENV];
  if (!config) return null;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4px 16px',
        background: config.color,
        color: '#fff',
        fontSize: 13,
        fontWeight: 600,
        letterSpacing: 0.5,
        zIndex: 1000,
      }}
    >
      {config.label}
    </div>
  );
};

export default AppEnvBanner;
